export default __webpack_public_path__ + "static/media/campaigns.aced998d.xlsx";